import React from 'react'
import '../../_metronic/partials/MapComponents/MapDetail.css'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../_metronic/helpers'
import {
  ChartsWidget1,
  TablesWidget1,
  ListsWidget5,
  TablesWidget5,
} from '../../_metronic/partials/widgets'
import {useParams} from 'react-router-dom'
import tutorial from '../../_metronic/assets/images/tutorial.jpg'
import upload from '../../_metronic/assets/images/upload.png'

const UserDetail = () => {
  const {id} = useParams()

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>User 1 Details Page</h3>
          </div>

          <Link to='/user' className='btn btn-primary align-self-center'>
            {/* Link değişecek */}
            Go Back
          </Link>
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User ID</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>19229304</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Last Location</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>Social Island X:89 Y:80</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Map Visit</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Social Island - 2 Hours</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Last Login</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>17/11/2022 – 08:22</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Time Zone</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Istanbul +3 </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Download Speed</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>24 megabit</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Known Interfaces</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Macbook pro (Safari) </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>IP Numberss</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>192.0.0.150</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Amount Of Usage</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Details is coming later.</span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserDetail
